import { UploadOrgPictureRequestContent, UploadOrgPictureResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to get presigned URL for uploading organization picture
 * @param request Organization picture upload parameters
 * @returns Promise with presigned post data for S3 upload
 */
export const uploadOrgPictureApi = async (orgId: string): Promise<UploadOrgPictureResponseContent> => {
  const apiRequest = createApiRequest<UploadOrgPictureResponseContent>('post', '/orgs/uploadOrgPicture');
  const request: UploadOrgPictureRequestContent = { orgId };
  return apiRequest(request);
};
